import { buildUrl, handleResponse } from "./auth";

const buildQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => {
      const encoded =
        value instanceof Date ? value.toISOString() : String(value);
      return `${encodeURIComponent(key)}=${encodeURIComponent(encoded)}`;
    });
  return parts.length ? `?${parts.join("&")}` : "";
};

const parseFileName = (response) => {
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || null;
};

const fetchExport = async (path) => {
  const response = await fetch(buildUrl(path), { credentials: "include" });
  if (!response.ok) {
    const message = await response.text().catch(() => "");
    throw new Error(message || "Export failed.");
  }
  const blob = await response.blob();
  return { blob, fileName: parseFileName(response) };
};

export const getAdminAnalytics = (params) =>
  fetch(buildUrl(`/api/admin/analytics${buildQuery(params)}`), {
    credentials: "include",
  }).then(handleResponse);

export const exportAdminAnalytics = (params) =>
  fetchExport(`/api/admin/analytics/export${buildQuery(params)}`);

const adminAnalyticsApi = { getAdminAnalytics, exportAdminAnalytics };

export default adminAnalyticsApi;
